module.exports = __webpack_public_path__ + "static/down_app_store-f169fccdb1050ccfeb2d7644f31cb6b0.svg";